import * as React from 'react'
import { ConfirmationAlertShadcnComponent } from 'app/components/confirmation-alert/ConfirmationAlertShadcnComponent'
import { useConfirmationAlert, type ConfirmationOptions } from 'app/components/confirmation-alert/useConfirmationAlert'

export type { ConfirmationOptions }

const ConfirmationServiceContext = React.createContext<[(options: ConfirmationOptions) => Promise<void>, boolean]>([
  Promise.reject,
  false,
])

export const useConfirmation = () => React.useContext(ConfirmationServiceContext)

export const ConfirmationServiceProvider = ({ children }) => {
  const { providerValue, alertProps } = useConfirmationAlert()

  return (
    <>
      <ConfirmationServiceContext.Provider value={providerValue} children={children} />
      <ConfirmationAlertShadcnComponent
        open={alertProps.open}
        variant={alertProps.options.variant}
        title={alertProps.options.title}
        description={alertProps.options.description}
        submitLabel={alertProps.options.submitLabel}
        cancelLabel={alertProps.options.cancelLabel}
        onSubmit={alertProps.onSubmit}
        onClose={alertProps.onClose}
      />
    </>
  )
}
